// The country pickers' empty-state text. It used to be the first row of the
// country list, so it could be picked — and saved as a user's country, which some
// profiles still hold. Kept apart from the list so code in the entry chunk
// (analytics) can check for it without pulling every country in.
export const COUNTRY_PLACEHOLDER = 'Select Country';

export const isCountryPlaceholder = (value?: string | null): boolean =>
  (value || '').trim().toLowerCase() === COUNTRY_PLACEHOLDER.toLowerCase();
